<template>
  <module-configuration :data="config" :errors="errors" @save="fetchOrderStatuses">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Identificador da conta" :error="getError('auth.accountId')">
        <input class="form-input" placeholder="Digite o identificador da sua conta" v-model="config.auth.accountId">
        <small class="form-help">Esse identificador pode ser encontrado no painel administrativo da 1EG.</small>
      </form-group>
    </div>
    <div>
      <panel title="Produtos">
        <loader :loading="loading"/>

        <div class="l-row" v-if="!loading">
          <form-group label="Sincronizar produtos automaticamente">
            <label class="form-switch">
              <input type="checkbox" v-model="config.product.synchronize">
              <span class="form-switch__indicator"></span>
            </label>
            <small class="form-help">Define se os produtos da fonte de dados devem ser sincronizados
              automaticamente.</small>
          </form-group>

          <form-group label="Sincronizar apenas produtos ativos">
            <label class="form-switch">
              <input type="checkbox" v-model="config.product.lookupOnlyStatusActive">
              <span class="form-switch__indicator"></span>
            </label>
            <small class="form-help">Define se apenas produtos ativos na fonte de dados devem ser sincronizados.</small>
          </form-group>
        </div>
      </panel>

      <panel title="Centro de Distribuição">
        <loader :loading="loading"/>
        <form-group label="Centro de distribuição" :error="getError('config.product.warehouse')">
          <select v-model="config.product.warehouse" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsWarehouse" :key="options.id" :value="options.id">{{ options.name }}
            </option>
          </select>
        </form-group>
      </panel>

      <panel title="Variações">
        <loader :loading="loading"/>

        <div class="l-row" v-if="!loading">
          <form-group label="Cor" :error="getError('config.variationTemplate.color')">
            <select v-model="config.variationTemplate.color" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="Tamanho" :error="getError('config.variationTemplate.size')">
            <select v-model="config.variationTemplate.size" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="Voltagem" :error="getError('config.variationTemplate.voltage')">
            <select v-model="config.variationTemplate.voltage" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="Sabor" :error="getError('config.variationTemplate.flavor')">
            <select v-model="config.variationTemplate.flavor" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>
        </div>
      </panel>

      <panel title="Atributos Adicionais">
        <loader :loading="loading"/>

        <div class="l-row" v-if="!loading">
          <form-group label="Código do Fabricante" :error="getError('config.additionalAttributes.manufacturerReference')">
            <select v-model="config.additionalAttributes.manufacturerReference" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="Tempo de garantia" :error="getError('config.additionalAttributes.warrantyTime')">
            <select v-model="config.additionalAttributes.warrantyTime" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="Garantia" :error="getError('config.additionalAttributes.warranty')">
            <select v-model="config.additionalAttributes.warranty" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

          <form-group label="NCM" :error="getError('config.additionalAttributes.ncm')">
            <select v-model="config.additionalAttributes.ncm" class="form-select">
              <option :value="null">Selecione</option>
              <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
            </select>
          </form-group>

        </div>
      </panel>
    </div>

    <panel title="Configurações de genêro">
      <loader :loading="loading"/>
      <div class="l-row" v-if="!loading && attributes.length">

        <form-group label="Gênero" :error="getError('config.additionalAttributes.gender')">
          <select v-model="config.additionalAttributes.gender" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.gender && optionsGender.length" label="Masculino" :error="getError('config.genderMap.male')">
          <select v-model="config.genderMap.male" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsGender" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.gender && optionsGender.length" label="Feminino" :error="getError('config.genderMap.female')">
          <select v-model="config.genderMap.female" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsGender" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.gender && optionsGender.length" label="Unisex" :error="getError('config.genderMap.unisex')">
          <select v-model="config.genderMap.unisex" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsGender" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>

      </div>
    </panel>

    <panel title="Configurações de faixa etária">
      <loader :loading="loading"/>
      <div class="l-row" v-if="!loading && attributes.length">

        <form-group label="Faixa Etária" :error="getError('config.additionalAttributes.ageGroup')">
          <select v-model="config.additionalAttributes.ageGroup" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in attributes" :key="options.id" :value="options.id">{{ options.label }}</option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.ageGroup && optionsAgeGroup.length" label="Adulto" :error="getError('config.ageGroupMap.adult')">
          <select v-model="config.ageGroupMap.adult" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsAgeGroup" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.ageGroup && optionsAgeGroup.length" label="Infantil" :error="getError('config.ageGroupMap.kids')">
          <select v-model="config.ageGroupMap.kids" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsAgeGroup" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>

        <form-group v-if="config.additionalAttributes.ageGroup && optionsAgeGroup.length" label="Ambos"
                    :error="getError('config.ageGroupMap.both')">
          <select v-model="config.ageGroupMap.both" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="options in optionsAgeGroup" :key="options.value" :value="options.value">{{ options.value }}
            </option>
          </select>
        </form-group>
      </div>
    </panel>


    <panel title="Status de pedidos">
      <loader :loading="loading"/>

      <div slot="header-right">
        <a href="#" @click="fetchOrderStatuses()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>

      <div class="l-row" v-if="!fetching && statusesGroupedByType">
        <form-group :label="$t(`${statusName}.label`)" v-for="(statusValue, statusName) in getStatusByIdentifier('default')" :key="statusName" v-if="statusName !== 'identifier'">
          <select v-model="getStatusByIdentifier('default')[statusName]" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}
            </option>
          </select>
        </form-group>
      </div>

      <div v-else-if="!fetching" class="u-bolder t-error u-textCenter">Não foi possível buscar os status dos pedidos da
        1EG.
      </div>
    </panel>

    <panel title="Status de pedidos por marketplace">
      <div slot="header-right">
        <a href="#" @click="fetchOrderStatuses()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>

      <loader :loading="loading"/>

      <panel :title="module.name" v-for="module in modulesInstalled" :key="module" :useAcordion="true"
             :useToggleIcon="true" class="blue-panel">
        <panel>
          <div class="l-row" v-if="!fetching && statusesGroupedByType">
            <form-group :label="$t(`${statusName}.label`)" v-for="(statusValue, statusName) in getStatusByIdentifier(module.identifier)" :key="statusName" v-if="statusName !== 'identifier' && statusName !== 'exchange'">
              <select v-model="getStatusByIdentifier(module.identifier)[statusName]" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }} </option>
              </select>
            </form-group>
            <form-group :label="$t(`exchange.${statusName}.label`)" v-for="(statusValue, statusName) in getExchangeStatusByIdentifier(module.identifier)" :key="statusName" v-if="haveExchangeStatuses(module.identifier)">
              <select v-model="getExchangeStatusByIdentifier(module.identifier)[statusName]" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}
                </option>
              </select>
            </form-group>
          </div>

          <div v-else-if="!fetching" class="u-bolder t-error u-textCenter">Não foi possível buscar os status dos pedidos da 1EG.</div>
        </panel>
      </panel>
    </panel>
  </module-configuration>
</template>

<script>
  import { union } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import api from '@/api'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'ecommerce',
        identifier: 'oneeg'
      }
    },
    data: () => ({
      loading: true,
      type: 'ecommerce',
      identifier: 'oneeg',
      errors: [],
      config: {
        product: {
          synchronize: false,
          lookupOnlyStatusActive: false,
          warehouse: null
        },
        auth: {
          environment: 'sandbox',
          accountId: null,
          token: null
        },
        variationTemplate: {
          color: null,
          size: null,
          voltage: null,
          flavor: null
        },
        additionalAttributes: {
          gender: null,
          manufacturerReference: null,
          ageGroup: null,
          warrantyTime: null,
          warranty: null,
          ncm: null
        },
        genderMap: {
          male: null,
          female: null,
          unisex: null
        },
        ageGroupMap: {
          adult: null,
          kids: null,
          both: null
        },
        order: {
          forward: {
            status: []
          }
        }
      },
      attributes: [],
      optionsGender: [],
      optionsAgeGroup: [],
      optionsWarehouse: [],
      modulesWithExchangeStatuses: [
        {
          identifier: 'netshoes',
          status: {
            approved: null
          }
        }
      ]
    }),
    async mounted () {
      this.loading = true

      try {
        await this.fetchOrderStatuses()
        const modules = union([
          {
            name: 'Padrão',
            identifier: 'default'
          }
        ], this.modulesInstalled)

        for (let i in modules) {
          const module = modules[i]

          const newConfig = {
            identifier: module.identifier,
            approved: null,
            pending: null,
            canceled: null,
            shipped: null,
            delivered: null
          }

          if (this.haveExchangeStatuses(module.identifier)) {
            newConfig.exchange = this.getModuleWithExchangeStatuses(module.identifier).status
          }

          const config = this.getStatusByIdentifier(module.identifier)

          if (!config) {
            this.config.order.forward.status.push(newConfig)
          } else {
            for (let j in Object.keys(newConfig)) {
              const status = Object.keys(newConfig)[j]

              if (config[status] === undefined) {
                config[status] = newConfig[status]
              }
            }
          }
        }
        if (this.config.auth.token !== null && this.config.auth.token !== '') {
          await this.warehouseOptions()
          await this.variationTemplateOptions()
        }
        await this.onChangeGender(false)
        await this.onChangeAgeGroup(false)
      } catch (e) {
      // previne falta error
      } finally {
        this.loading = false
      }
    },
    methods: {
      ...mapActions('orderStatuses', [
        'fetch'
      ]),
      async fetchOrderStatuses () {
        await this.fetch({
          type: this.type,
          identifier: this.identifier
        })
      },
      onChangeGender (canResetGender) {
        this.optionsGender.splice(0, this.optionsGender.length)
        if (canResetGender) {
          this.config.genderMap.male = null
          this.config.genderMap.female = null
          this.config.genderMap.unisex = null
        }

        if (this.config.additionalAttributes.gender === null || !this.attributes.length) {
          return []
        }

        const genderOptions = this.attributes.find(options => options.id === this.config.additionalAttributes.gender)

        for (let i in genderOptions.values) {
          this.optionsGender.push({
            value: genderOptions.values[i]
          })
        }
      },
      onChangeAgeGroup (canResetAgeGroup) {
        this.optionsAgeGroup.splice(0, this.optionsAgeGroup.length)
        if (canResetAgeGroup) {
          this.config.ageGroupMap.adult = null
          this.config.ageGroupMap.kids = null
          this.config.ageGroupMap.both = null
        }

        if (this.config.additionalAttributes.ageGroup === null || !this.attributes.length) {
          return []
        }

        const ageGroupOptions = this.attributes.find(options => options.id === this.config.additionalAttributes.ageGroup)

        for (let i in ageGroupOptions.values) {
          this.optionsAgeGroup.push({
            value: ageGroupOptions.values[i]
          })
        }
      },
      async warehouseOptions () {
        try {
          const warehouses = await api.oneeg.getWarehouses()
          for (const warehouse of warehouses) {
            this.optionsWarehouse.push(warehouse)
          }
        } catch (e) {
          this.optionsWarehouse.splice(0, this.optionsWarehouse.length)
        }
      },
      getError (input) {
        const error = this.errors.find(item => item.input === input)
        return error ? { message: error.message, value: error.value } : { message: null, value: null }
      },
      getStatusByIdentifier (identifier) {
        return this.config.order.forward.status.find(status => status.identifier === identifier)
      },
      getExchangeStatusByIdentifier (identifier) {
        return this.config.order.forward.status.find(status => status.identifier === identifier)['exchange']
      },
      haveExchangeStatuses (identifier) {
        return this.getModuleWithExchangeStatuses(identifier) !== undefined
      },
      getModuleWithExchangeStatuses (identifier) {
        return this.modulesWithExchangeStatuses.find(moduleWithExchangeStatuses => identifier === moduleWithExchangeStatuses.identifier)
      },
      async variationTemplateOptions () {
        try {
          const attributes = await api.oneeg.getVariationTemplate()
          for (const attribute of attributes) {
            this.attributes.push(attribute)
          }
        } catch (e) {
          this.attributes.splice(0, this.attributes.length)
        }
      }
    },
    computed: {
      ...mapGetters('orderStatuses', [
        'findByModuleTypeAndIdentifier'
      ]),
      ...mapGetters('module', [
        'definitionMarketplacesInstalled'
      ]),
      ...mapFields({
        fetching: 'orderStatuses.fetching'
      }),
      modulesInstalled () {
        return this.definitionMarketplacesInstalled
      },
      statusesGroupedByType () {
        return this.findByModuleTypeAndIdentifier(this.type, this.identifier)
      }
    },
    watch: {
      'config.additionalAttributes.ageGroup' () {
        if (this.loading) {
          return null
        }
        this.onChangeAgeGroup(true)
      },
      'config.additionalAttributes.gender' () {
        if (this.loading) {
          return null
        }
        this.onChangeGender(true)
      }
    },
    components: {
      api,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Oneeg.vue?1714b063